import { render, staticRenderFns } from "./invoicesBalance.vue?vue&type=template&id=c50c72cc&"
import script from "./invoicesBalance.vue?vue&type=script&lang=js&"
export * from "./invoicesBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports